require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-10-04-goodbye-rdbms.json") })
        }
      }, "path---articles-2007-10-04-goodbye-rdbms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-10-04-goodbye-rdbms!./.cache/json/articles-2007-10-04-goodbye-rdbms.json
// module id = 535
// module chunks = 231608221292675